<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <button 
    v-if="sectorToggle" 
    :class="classes"
    @click="handleClick" 
    :aria-pressed="selected" 
    :aria-label="ariaLabel"
    >
    <div class="relative z-2 flex items-center gap-2">
       {{ label }}<span class="font-bold" v-if="count">{{ count }}</span>
    </div>
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface ButtonProps {
  label: string;
  count?: string;
  classes?: string;
  theme: "dark" | "light";
  type?: "primary" | "secondary";
  selected?: boolean;
  sectorToggle?: boolean;
  isClearButton?: boolean;
}

const props = withDefaults(defineProps<ButtonProps>(), {
  selected: false,
  theme: "light",
  type: "primary",
  sectorToggle: true,
});

type Emits = {
  (e: "handleClick"): void;
};
const emit = defineEmits<Emits>();

const handleClick = () => {
  emit("handleClick");
};

const ariaLabel = computed(() => {
  if (props.isClearButton) {
    return `Clear filter: ${props.label}`;
  }
  if (!props.isClearButton) {
    return `filter by: ${props.label}`;
  }
  return "";
});

const colorLight = computed(() => {
  return props.selected
    ? "text-white border-aubergine hover:border-aubergine bg-aubergine"
    : "text-aubergine border-aubergine-40 hover:border-aubergine";
});
const colorDark = computed(() => {
  return props.selected
    ? "text-aubergine border-white hover:border-white bg-white"
    : "text-white border-white-40 hover:border-white";
});

const themeStyles = computed(() => {
  return props.theme === "light" ? colorLight.value : colorDark.value;
});

const classes = computed(() => {
  return `overflow-hidden inline-block group relative text-button border-2 ${themeStyles.value} ${props.classes} linkTransition px-4 py-2`;
});
</script>
